import { useEffect, useRef } from "react"
import { deserialize } from "jsonapi-deserializer"
import { useSelector, useDispatch } from "react-redux"

import consumer from "~/channels/consumer"
import { postEvent } from "~/utils/EventManager"
import { setSpaces, getUser, setSpaceName } from "~/store"
import { Subscription } from "@rails/actioncable"
import { Space } from "~/types"

export default function SpacesChannel() {
  const dispatch = useDispatch()
  const subscription = useRef<Subscription | null>(null)
  const user = useSelector(getUser)
  const organisationName = user?.organisation_name

  useEffect(() => {
    subscription.current = consumer.subscriptions.create(
      { channel: "SpacesChannel", organisationName },
      {
        connected() {
          postEvent(null, "userConnected")
        },
        received(data) {
          const parsedSpaces = deserialize(data["value"]) as Space[]
          const currentSpace = parsedSpaces.find((space) =>
            space.users.find((u) => u.id === user?.id),
          )
          dispatch(setSpaces(parsedSpaces))
          if (currentSpace) {
            dispatch(setSpaceName(currentSpace.name))
          }
        },
      },
    )
    return () => {
      subscription.current?.unsubscribe()
    }
  }, [])

  return null
}
